import React from 'react';
import { formatUserProfile } from 'selectors/user.selectors';
import ProfileInput from './input';

const config = {
  // General
  format: formatUserProfile,
  emptyMessage: 'Please select a User',
  title: 'User Profile',
  component: props => (
    <ProfileInput
      {...props}
      title="User Profile"
    />
  )
};

export default config;
